module.exports = __webpack_public_path__ + "newsletter/Components/PocketHitsCta/nl-signup-illustration.8cd3b7c8fe5150de202c502619b5c190.jpg";